const value = {
    usersProjectRole: 'Participant, project, or role',
    championsFirst: 'Champions first',
    newFirst: 'Juniors first',
    usersRating: 'Leaderboard',
    fullName: 'Full name',
    projects: 'Projects',
    role: 'Role',
    score: 'Score',
    level: 'Level',
  };

export default value;
